import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100vh",
    width: "100%",
    overflow: "hidden",
  },
  content: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    backgroundColor: "#F3F4F6", // Light gray background for the app content area
  },
  mainArea: {
    flexGrow: 1,
    overflowY: "auto",
    padding: theme.spacing(3),
  },
}));
